import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { getAllMembers } from "app/services/MasterAdmin & ApiUSer/rdsServices";

function AllMemberAutoComplete(props) {
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  // handle input change event
  const handleInputChange = (value) => {
    setInputValue(value);
  };

  const handleChange = (value) => {
    setSelectedValue(value);
    props.setFieldValue("memberId", value.id);
    props.setFieldValue("balance", value.balance);
    props.handleChangeOptions(value.id);
  };

  const refreshFilter = () => {
    props.refreshFilter();
  };

  // load options using API call
  const loadOptions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const { data } = await getAllMembers(inputValue);
    const memberData = [];

    if (data?.data?.length > 0) {
      data.data.forEach((item) =>
        memberData.push({
          id: item.memId,
          label: `${item.uniqueIdentity} - ${item.company} - ${item.memberMobileNo} - ${item.memberType}`,
          balance: `${item.balance}`,
        })
      );
    }

    return memberData;
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      value={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name="memberId"
    />
  );
}

export default AllMemberAutoComplete;
